export const Types = {
    GET_POOL_LIST: "GET_POOLS",
    SET_POOL_LIST: "SET_POOLS",
    GET_UNPLANNED_MAINTENANCE: "GET_UNPLANNED_MAINTENANCE",
    SET_UNPLANNED_MAINTENANCE: "SET_UNPLANNED_MAINTENANCE",
    GET_UNPLANNED_MAINTENANCE_MULTIPLE: "GET_UNPLANNED_MAINTENANCE_MULTIPLE",
    SET_UNPLANNED_MAINTENANCE_MULTIPLE: "SET_UNPLANNED_MAINTENANCE_MULTIPLE",
    GET_MAINTENANCE_STATUS_LIST: "GET_MAINTENANCE_STATUS_LIST",
    SET_MAINTENANCE_STATUS_LIST: "SET_MAINTENANCE_STATUS_LIST",
    GET_COUNTS: "GET_COUNTS",
    SET_COUNTS: "SET_COUNTS",
    GET_TECH_LIST: "GET_TECH_LIST",
    SET_TECH_LIST: "SET_TECH_LIST",
    GET_AREAS: "GET_AREAS",
    SET_AREAS: "SET_AREAS",
    GET_EQUIPMENT_MAIN_LIST: "GET_EQUIPMENT_MAIN_LIST",
    SET_EQUIPMENT_MAIN_LIST: "SET_EQUIPMENT_MAIN_LIST",
    GET_EQUIPMENT_SUB_LIST: "GET_EQUIPMENT_SUB_LIST",
    SET_EQUIPMENT_SUB_LIST: "SET_EQUIPMENT_SUB_LIST",
    GET_REASON_GROUP: "GET_REASON_GROUP",
    SET_REASON_GROUP: "SET_REASON_GROUP",
    GET_EFFECTS: "GET_EFFECTS",
    SET_EFFECTS: "SET_EFFECTS",
    RESET_STORE: "RESET_STORE",
    GET_COST_CENTERS: "GET_COST_CENTERS",
    SET_COST_CENTERS: "SET_COST_CENTERS",
    SET_AREA_LIST_TO_NULL: "SET_AREA_LIST_TO_NULL",
    RESET_COUNTS: "RESET_COUNTS",
    RESET_TECH_LIST: "RESET_TECH_LIST",
    RESET_FILTER: "RESET_FILTER",
    GET_EXCEL: "GET_EXCEL",
};

export const downloadExcelFile = (payload) => ({
    type: Types.GET_EXCEL,
    payload,
});

export const getPoolList = (shouldFireStatus) => ({
    type: Types.GET_POOL_LIST,
    payload: shouldFireStatus,
});

export const setPoolList = (payload) => ({
    type: Types.SET_POOL_LIST,
    payload: payload,
});

export const getStatusList = () => ({
    type: Types.GET_MAINTENANCE_STATUS_LIST,
});

export const setStatusList = (payload) => ({
    type: Types.SET_MAINTENANCE_STATUS_LIST,
    payload: payload,
});

export const getActiveCounts = (payload) => ({
    type: Types.GET_COUNTS,
    payload,
});

export const getTechList = (payload) => ({
    type: Types.GET_TECH_LIST,
    payload: payload,
});

export const setTechList = (payload) => ({
    type: Types.SET_TECH_LIST,
    payload: payload,
});

export const getAreaList = () => ({
    type: Types.GET_AREAS,
});

export const setAreaList = (payload) => ({
    type: Types.SET_AREAS,
    payload,
});

export const getCostCenterList = () => ({
    type: Types.GET_COST_CENTERS,
});

export const setCostCenterList = (payload) => ({
    type: Types.SET_COST_CENTERS,
    payload: payload,
});

export const setAreaListToNull = () => ({
    type: Types.SET_AREA_LIST_TO_NULL,
});

export const getEquipmentMainList = (payload) => ({
    type: Types.GET_EQUIPMENT_MAIN_LIST,
    payload: payload,
});

export const setEquipmentMainList = (payload) => ({
    type: Types.SET_EQUIPMENT_MAIN_LIST,
    payload: payload,
});

export const getEquipmentSubList = (payload) => ({
    type: Types.GET_EQUIPMENT_SUB_LIST,
    payload: payload,
});

export const setEquipmentSubList = (payload) => ({
    type: Types.SET_EQUIPMENT_SUB_LIST,
    payload: payload,
});

// getEquipmentSubList

export const setActiveCounts = (payload) => ({
    type: Types.SET_COUNTS,
    payload: payload,
});

export const getUnPlannedMaintenanceList = (payload) => ({
    type: Types.GET_UNPLANNED_MAINTENANCE,
    payload: payload,
});

export const setUnPlannedMaintenanceList = (payload) => ({
    type: Types.SET_UNPLANNED_MAINTENANCE,
    payload: payload,
});

export const getUnPlannedMaintenanceListMultiple = (payload) => ({
    type: Types.GET_UNPLANNED_MAINTENANCE_MULTIPLE,
    payload: payload,
});

export const setUnPlannedMaintenanceListMultiple = (payload) => ({
    type: Types.SET_UNPLANNED_MAINTENANCE_MULTIPLE,
    payload: payload,
});
// filter actions
export const getReasonGroup = () => ({
    type: Types.GET_REASON_GROUP,
});

export const setReasonGroup = (payload) => ({
    type: Types.SET_REASON_GROUP,
    payload: payload,
});

export const getEffects = () => ({
    type: Types.GET_EFFECTS,
});

export const setEffects = (payload) => ({
    type: Types.SET_EFFECTS,
    payload: payload,
});

export const resetTechStore = () => ({
    type: Types.RESET_TECH_LIST,
});

export const clearFilterRes = () => ({
    type: Types.RESET_FILTER,
});

export const resetCounts = () => ({
    type: Types.RESET_COUNTS,
});

export const resetStore = () => ({
    type: Types.RESET_STORE,
});
